import { getShoppingContext } from 'redux/modules/sessions/actions/get-shopping-context';
import { getCustomerDataIfLoggedIn } from 'redux/modules/sessions/get-customer-data-if-logged-in';

export const refreshShoppingContext = (dispatch, getState) =>
  dispatch(getShoppingContext()).then(() => getCustomerDataIfLoggedIn(dispatch, getState));
